<!-- This component is used to display the summary of Everplans Enrollment -->
<template>
	<div>
		<h2 class="font-bold text-blue-700">{{ t('everplans.title') }}</h2>
		<div class="my-6 flex gap-2">
			<h1 class="text-3xl font-bold">{{ formattedPrice }}</h1>
		</div>
		<div class="flex items-center justify-between text-slate-500">
			<h4>{{ t('summary.total') }}</h4>
			<span>{{ formattedPrice }}</span>
		</div>

		<hr class="my-4 border-gray-200" />

		<div class="flex items-center justify-between">
			<h4>{{ t('summary.dueToday') }}</h4>
			<span class="font-bold">{{ formattedPrice }}</span>
		</div>
	</div>
</template>

<script setup lang="ts">
import { usePresentationLocale } from '@/i18n'
import { computed } from 'vue'

const { n, t } = usePresentationLocale()

const props = defineProps({
	price: {
		type: Number,
		required: true,
	},
})

const formattedPrice = computed(() => n(props.price, 'currency'))
</script>
